<template>
  <div class="disease-list-wrapper">
    <div class="disease-top">
      <div class="disease-search">
        <div action="" class="search-box">
          <!-- @submit.prevent="searchDisease"-->
          <icon icon-class="search"></icon>
          <input type="search" ref="searchInput" placeholder="请搜索疾病名城" v-model="searchKey" @input="searchDiseases($event)"
            name="" id="">
            <!--
          <icon icon-class="close" class="clear" @click.native="clearSearch" v-show="searchKey"></icon>
          -->
        </div>
        <div class="cancel-disease">取消</div>
      </div>
      <div class="disease-selected">

      </div>
    </div>

    <!--
    <div class="list-loading" v-if="!dataDone">
      <van-loading type="spinner" size="14px">正在加载中...</van-loading>
    </div>
    -->

    <div class="disease-list" v-if="dataDone && diseaseList.length > 0">
      <div tag="div" class="disease-item" :key="index" v-for="(item, index) in diseaseList">
        <div class="disease-box">
          <div class="disease-name">{{item.gb_name}}</div>

        </div>
      </div>

      <div class="data-loading" v-if="!isOver">
        <van-loading type="spinner" size="14px">加载中...</van-loading>
      </div>

      <div class="data-finish" v-if="isOver">无更多数据</div>
    </div>

  </div>
</template>

<style lang="less" scoped>
  .disease-list-wrapper{
    min-height: 100vh;
    background: #FAFAFA;
    .list-loading{
      padding-top: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .disease-top{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 117px;
      .disease-selected{
        width:100%;
        background-color: #FAFAFA;
        height: 50px;
        margin:0px auto 0px auto
      }
    }
    .disease-search{
      width: 100%;
      height: 57px;
      border-bottom: 1px solid #eae9e8;
      padding: 10px 16px;
      background: #FFF;
      z-index: 10;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .cancel-disease{
        font-size: 14px;
        color: #666666;
        font-weight: normal;
        background: transparent;
        padding:3px 3px;
        height: 50px;
        line-height: 50px;
        width: 60px;
        text-align: center;

      }
      .search-box{
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #F7F7F7;
        border-radius: 3px;
        overflow: hidden;
        svg{
          font-size: 16px;
          color: #CCC;
          margin-left: 13px;
          &.clear{
            color: #999;
            margin-right: 8px;
            font-size: 14px;
          }
        }
        input{
          flex: 1;
          height: 100%;
          background: #F7F7F7;
          font-size: 14px;
          color: @black;
          padding: 0 8px;
          &[type=search]::-webkit-search-cancel-button{
            -webkit-appearance: none;
          }
        }
      }
    }

    .disease-list{
      width: 100%;
      flex-wrap: wrap;
      margin:0px auto;
      background-color: #FAFAFA;
      padding-top: 117px;
      .disease-item{
        width: 100%;
        height: 38px;
        font-size: 15px;
        color:#444444;
        padding-left: 15px;
        .disease-box{
          margin-top: 2px;
          border-bottom: 1px solid #FAFAFA;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 4px;
          padding-bottom: 5px;
          padding-left: 10px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        searchKey: '',
        diseaseList: [],
        page: 1,
        isOver: false,
        timer: null,

      }
    },
    created() {
      //this.getDiseaseList();
    },
    mounted() {
       window.addEventListener('scroll', this.scrollToLoad);
    },
    beforeDestroy() {
       window.removeEventListener('scroll', this.scrollToLoad);
    },
    methods: {
      getDiseaseList(type = 'normal', cb) {
        this.$root.post('/disease', {
          count: 30,
          page: this.page,
          search: this.searchKey
        }).then(data => {
          this.dataDone = true;
          if (data && data.info.length <= 0 && type == 'search' && this.diseaseList.length > 0) {
            this.$notify('暂无搜索结果');
          }
          this.isOver = data.is_over == 1 ? true : false;
          if (data && data.info.length > 0) {
            if (type == 'search') {
              this.diseaseList = data.info;
            } else {
              this.diseaseList = [...this.diseaseList, ...data.info];
            }
          }

          if (cb) cb();
        })
      },
      // 经方模板列表滚动加载
      scrollToLoad() {
        if (!this.isOver) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            let pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight);
            let viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight ||
              0;
            let scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop ||
              0;
            if (pageHeight - viewportHeight - scrollHeight < 20) {
              this.page++;
              this.getDiseaseList();
            }
          }, 200);
        }
      },
      searchDisease() {
        this.$toast.loading({
          duration: 0,
          loadingType: 'spinner',
          message: '搜索中...'
        })
        this.page = 1;
        this.getDiseaseList('search', () => {
          window.scrollTo(0, 0);
          this.$toast.clear();
          //this.$refs.searchInput.blur();
        });
      },
      searchDiseases($event) {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (this.searchKey != '') {
            this.page = 1;
            this.getDiseaseList('search', () => {
              window.scrollTo(0, 0);
              this.$toast.clear();

            });
          }else{
            this.diseaseList=[];
          }
          this.timer = null;
        }, 500)
      },
      clearSearch() {
        this.searchKey = '';
        window.scrollTo(0, 0);
        this.page = 1;
        this.getDiseaseList('search');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Disease/gb95.vue